import React, { Component } from 'react';
import About from './About';
import Spinner from '../../common/Spinner/Spinner';
import imagePlaceholder from '../../../assets/image-placeholder.svg';
import config from '../../../config';


class AboutContainer extends Component {
  state = {
    image: '',
    content: ''
  };

  async componentDidMount() {
    const res = await fetch(`${config.fetchURL}/pages?_embed&slug=rolam`);
    const data = await res.json();

    this.setState({
      content: data[0].acf.nyitooldal,
      image: (data[0]._embedded) ? data[0]._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url : imagePlaceholder
    });
  }

  render() {
    const { image, content } = this.state;

    if (content.length > 0) {
      return <About image={image} content={content} />;
    } else {
      return (
        <section className="about">
          <Spinner style={{ marginTop: '122px', marginBottom: '122px' }} />
        </section>
      );
    }
  }
}


export default AboutContainer;



// WEBPACK FOOTER //
// ./src/components/Home/About/AboutContainer.js